import { BaseTable, FooterMenu, HeaderMenu, Loading, PaginationData, TableHeader } from "components"
import moment from "moment"
import { useState } from "react"
import { DashboardFillType, PaginationState } from "types"
import { convertNumber, default_pagination_value, exportPdf } from "utils"
import { useCurrentStockPositionValue } from "./utils/hooks/useCurrentStockPositionValue"
import { FilterCurrentPositionValue } from "./components/Section/FilterCurrentStockPosition"
import { ExportExcelStockPositionValue, ExportPdfStockPositionValue } from "./components"


type FilterType = PaginationState & DashboardFillType & {
    category_id: string
}

export function CurrentStockPosition() {
    const month = moment().format("MM")
    const year = moment().format("YYYY")
    const [fill, setFill] = useState<FilterType>({
        ...default_pagination_value,
        month,
        year,
        location_id: "",
        category_id: "",
    })

    const { data, isLoading, pagination, fetchAll } = useCurrentStockPositionValue({
        year_month: `${fill.year}${fill.month}`,
        location_id: fill.location_id,
        category_id: fill.category_id,
        page: fill.page,
        limit: fill.limit
    })

    return (
        <section className="container my-5 flex flex-col gap-3">
            <HeaderMenu title="CURRENT STOCK POSITION VALUE" />

            <section className="flex flex-col gap-3">
                <section className="flex flex-col">
                    <FilterCurrentPositionValue
                        onChangeFilter={(res) => setFill({
                            ...fill,
                            month: moment(res.date_from).format("MM"),
                            year: moment(res.date_from).format("YYYY"),
                            location_id: res.location_id,
                            category_id: res.category_id?.toString() ?? "",
                        })}
                    />

                </section>

                <section className="flex flex-col mt-5">
                    <section className="grow">
                        <div className="max-h-[600px] overflow-y-auto">
                            <BaseTable>
                                <TableHeader>
                                    <tr>
                                        <th>CODE</th>
                                        <th>PRODUCT NAME</th>
                                        <th>RETAIL VALUE</th>
                                        <th>COGM VALUE</th>
                                        <th>AVG VALUE</th>
                                        <th>GMP %</th>
                                        <th>PROFIT</th>
                                    </tr>
                                </TableHeader>
                                <tbody>

                                    {isLoading ? (
                                        <tr>
                                            <td colSpan={9} className="text-center">
                                                <Loading loading={isLoading} errorText="No data available" />
                                            </td>
                                        </tr>
                                    ) : data.length === 0 ? (
                                        <tr>
                                            <td colSpan={9} className="text-center">
                                                <div className="text-center">No data available</div>
                                            </td>
                                        </tr>
                                    ) : (
                                        data.map(item => (
                                            <tr key={item.product_id}>
                                                <td className="text-left">{item?.product_barcode ?? "-"}</td>
                                                <td className="text-left">{item?.product_name ?? "-"}</td>
                                                <td className="text-right">{convertNumber(item?.retail_value || 0)?.intoCurrency ?? "-"}</td>
                                                <td className="text-right">{convertNumber(item?.cogm_value || 0)?.intoCurrency ?? "-"}</td>
                                                <td className="text-right">{convertNumber(item?.avg_price || 0)?.intoCurrency ?? "-"}</td>
                                                <td className="text-center">
                                                    {item?.soh && item?.soh > 0 && item?.retail_value
                                                        ? `${convertNumber((item?.retail_value - item?.cogm_value) / item?.retail_value * 100).intoNormalAmount}%`
                                                        : "0"}
                                                </td>
                                                <td className="text-right">
                                                    {convertNumber(item?.retail_value - item?.cogm_value).intoCurrency}
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </BaseTable>
                        </div>
                        <div className="mt-5">
                            <PaginationData
                                data={{
                                    pagination_data: pagination
                                }}
                                pagination={fill}
                                setPagination={setFill as React.Dispatch<React.SetStateAction<PaginationState>>}
                            />
                        </div>
                    </section>
                </section>

                <section className="mt-2">
                    <FooterMenu
                        export={{
                            actiontype: "export",
                            onClick: async () => {

                                const fullData = await fetchAll();

                                ExportExcelStockPositionValue({
                                    dataList: fullData || [],
                                })
                            }
                        }}
                        pdf={{
                            actiontype: "pdf",
                            onClick: async () => {
                                 
                                const fullData = await fetchAll();

                                exportPdf({
                                    documentComponent: <ExportPdfStockPositionValue dataList={fullData || []} />,
                                    fileName: "Current_Stock_Position_Value"
                                })
                            }
                        }}
                    />
                </section>
            </section>
        </section>
    )
}
